import { css } from '@emotion/core'
import { colors, font } from 'styles/variables'
import { darken } from 'utils/styles'

export const header = css`
  display: flex;
  align-items: center;
`

export const createControlCss = (main, hover) => css`
  color: ${main};

  :hover {
    color: ${hover};
  }
`

// Both can be combined
export const control = createControlCss(
  colors.primaries.primary1,
  colors.primaries.primary4
)

export const cancel = createControlCss(
  colors.errors.error2,
  darken(colors.errors.error2, 20)
)

export const icon = css`
  font-size: ${font.size18};
  color: ${colors.white100};
`
